import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=d12e048e&scoped=true"
import script from "./EmptyComponent.vue?vue&type=script&lang=ts"
export * from "./EmptyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12e048e",
  null
  
)

export default component.exports